import { hanwahaInstance } from '../../shared_elements';

const qbProvider = hanwahaInstance ? 'hanwha-qb' : 'quickbooks';

export const syncChartOfAccountsApi = () =>{
   return `/integrations/${qbProvider}/chart-of-accounts/sync/`;
}

export const syncProductServiceApi = () => {
   return `/integrations/${qbProvider}/products-services/sync/`;
}

export const syncClassesApi = () => {
   return `/integrations/${qbProvider}/classes/sync/`;
}

export const syncInvoicesApi = () => {
   return `/integrations/${qbProvider}/invoices/sync/`;
}

export const pullInvoicePaymentsApi = () => {
   return `/integrations/${qbProvider}/invoices/pull-payments/`;
}

export const getQbStatusApi = () => {
   return `/integrations/${qbProvider}/status/`;
}